/**
 * This enhances the native html5 lazy loading by adding
 * state representing classes to the assets container.
 * _loading-states.scss is needed for this to work properly.
 * @author Thomas Franz <thomas.franz@krankikom.de>
 * @version 1.2.0
 */

const classPrefix = "loading-state";
const stateClass = {
  waiting: classPrefix + "--waiting",
  error: classPrefix + "--error",
  errorShow: classPrefix + "--error-show",
  loaded: classPrefix + "--loaded",
};

try {
  if ("loading" in HTMLImageElement.prototype && "loading" in HTMLIFrameElement.prototype) {
    const loadingState = (lazyEl) => {
      if (lazyEl) {
        const lazyElAsset = lazyEl.querySelector('[loading="lazy"]');
        if (lazyElAsset) {
          lazyEl.loadingState = { state: "waiting" };

          const onLoad = () => {
            lazyEl.classList.remove(stateClass.waiting);
            lazyEl.classList.add(stateClass.loaded);
            lazyEl.loadingState.state = "loaded";
          };

          const onError = () => {
            lazyEl.classList.remove(stateClass.waiting);
            lazyEl.classList.add(stateClass.error);
            lazyEl.loadingState.state = "error";
            setTimeout(() => {
              lazyEl.classList.add(stateClass.errorShow);
            }, 100);
          };

          const tagName = lazyElAsset.tagName;
          if (tagName === "IFRAME") {
            lazyEl.classList.add(stateClass.waiting);
            lazyElAsset.onload = onLoad;
          } else if (tagName === "IMG") {
            if (!lazyElAsset.complete) {
              lazyEl.classList.add(stateClass.waiting);
              lazyElAsset.addEventListener("load", onLoad, false);
              lazyElAsset.addEventListener("error", onError, false);
            }
          }
        }
      }
    };

    const loadingStateAll = () => {
      if (loadingState) {
        const lazyEls = [...document.querySelectorAll(`.${classPrefix}`)].filter(
          (lazyEl) => !lazyEl.loadingState,
        );
        lazyEls.forEach((lazyEl) => {
          loadingState(lazyEl);
        });
      }
    };

    loadingStateAll();
    window.addEventListener("filmfilter_apply_filters_finished", () => {
      loadingStateAll();
    });
  }
} catch (error) {
  console.error(error);
}
